<template>
  <v-dialog
    scrollable
    v-model="visable"
    max-width="600px"
    :persistent="true"
  >
    <v-card>
      <v-card-title class="subheading">
        {{ loading ? '正在提交…': '审核' }}
      </v-card-title>

      <v-divider/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <p class="subheading">{{ message }}</p>
        <v-divider class="pb-1"/>
        <p>审核结论</p>
        <v-radio-group v-model="status" column hide-details class="px-2">
          <v-radio
            v-for="a in actions"
            :label="a.name"
            :value="a.action"
            :key="a.dbid"
          />
        </v-radio-group>
        <v-textarea
          label="审核意见"
          v-model="note"
          counter="200"
          persistent-hint
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn flat color="primary" @click.native="$emit('input', false)">取消</v-btn>
        <v-btn color="primary" :disabled="loading" @click.native="onSubmit">提交</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    model: {
      prop: 'visable',
      event: 'input'
    },

    props: ['visable', 'message', 'uri', 'dbid','flbh', 'actions'],

    data() {
      return {
        loading: false,
        status: '',
        note: ''
      }
    },

    methods: {
      /**
       * **************************************************************
       * 异步数据请求
       */
      onSubmit() {
        this.loading = true;
        const param = window.xutil.param("note", this.note);
        this.axios.put(`${this.uri}/${this.status}/${this.dbid}`+`?flbh=${this.flbh}`, param)
          .then(rsp => {
            // 填充对话框
            this.$emit('ok', rsp.data);
            this.$emit('input', false);
            this.loading = false;
          });
      }
    }
  }
</script>
